import { createContext } from "react";
import type { GroupByOption, GroupBySortDirection, SortDirection, SortOption } from "types/SortingAndGroupingPreferences";

export const ContentSortingGroupingContext = createContext({
  sortName: "Date" as SortOption,
  sortDirection: "ASC" as SortDirection,
  groupByName: "" as GroupByOption,
  groupByDirection: "ASC" as GroupBySortDirection,
});
